module.exports = __webpack_public_path__ + "img/usdt.839a0f0d.png";